import React, { useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { Customer } from '../../../core/api/models';
import { Controller, useForm } from 'react-hook-form';
import ErrorMessage from '../../../components/text/ErrorMessage';
import api from '../../../api';

interface FormProps {
  otp: string;
}

const SearchCustomer: React.FunctionComponent<{
  error?: string;
  verifyOtp: (otp: string) => void;
  setStage: (stage: string) => void;
  phone?: string;
  customerDetails?: Customer;
}> = (props) => {
  const [isButtonDisabled, setButtonDisabled] = useState<boolean>(true);
  const [isSubmiting, setSubmiting] = React.useState(false);
  const { register, handleSubmit, errors, control } = useForm<FormProps>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });

  const onSubmit = (data: { otp: string }) => {
    props.verifyOtp(data.otp);
  };

  const handleChange = (e: { target: { value: any } }) => {
    setButtonDisabled(!e.target.value);
  };

  const onSendSms = async () => {
    setSubmiting(true);
    try {
      const response = await api.customer.unlinkPhoneSendSms(
        props.phone || '',
        props.customerDetails?._id
      );
      toastr.success('Success', 'OTP sent successfully');
    } catch (error) {
      toastr.error('Error', error?.response?.data?.message);
    }
    setSubmiting(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="p-4">
        <div className="form-group font-weight-semibold mb-4">
          <label htmlFor="" className="font-sm text-uppercase">
            Enter otp<span className="text-danger">*</span>
          </label>

          <Controller
            control={control}
            name="otp"
            rules={{ required: true }}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="OTP"
                name="otp"
                ref={register({ required: true })}
                id="otp"
                onChange={(e) => {
                  handleChange(e);
                  onChange(e.target.value);
                }}
              />
            )}
          ></Controller>

          {errors.otp && (
            <ErrorMessage>
              {errors.otp.type === 'required'
                ? 'otp is required'
                : 'Invalid otp'}
            </ErrorMessage>
          )}
        </div>
        <div className="form-group text-right">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={() => props.setStage('existing-customer')}
            disabled={isSubmiting}
          >
            Back
          </button>
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={() => onSendSms()}
            disabled={isSubmiting}
          >
            Resend
          </button>
          <button
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={isButtonDisabled || isSubmiting}
          >
            Verify
          </button>
        </div>
      </div>
    </form>
  );
};

export default SearchCustomer;
